import { createReducer } from 'redux-act';
import { createActionCRUDResources } from 'shared/utils/reducerHelper';
import { delay } from 'shared/utils/utilHelper';

const initialState = {
  fetchLoading1: false,
  fetchLoading2: false,
  data1: [],
  data2: [],
  error1: false,
  error2: false,
  message1: '',
  message2: ''
};

const fetchSmartInModeTable1 = createActionCRUDResources(
  'fetch smart in mode table 1'
);

const fetchSmartInModeTable2 = createActionCRUDResources(
  'fetch smart in mode table 2'
);

export default createReducer(
  {
    [fetchSmartInModeTable1.fetch.start]: (state) => ({
      ...state,
      fetchLoading1: true,
      error1: false
    }),
    [fetchSmartInModeTable1.fetch.success]: (state, payload) => ({
      ...state,
      data1: payload,
      fetchLoading1: false,
      error1: false
    }),
    [fetchSmartInModeTable1.fetch.error]: (state, payload) => ({
      ...state,
      message1: payload,
      error1: true,
      data1: [],
      fetchLoading1: false
    }),
    [fetchSmartInModeTable2.fetch.start]: (state) => ({
      ...state,
      fetchLoading2: true,
      error2: false
    }),
    [fetchSmartInModeTable2.fetch.success]: (state, payload) => ({
      ...state,
      data2: payload,
      fetchLoading2: false,
      error2: false
    }),
    [fetchSmartInModeTable2.fetch.error]: (state, payload) => ({
      ...state,
      message2: payload,
      error2: true,
      data2: [],
      fetchLoading2: false
    })
  },
  initialState
);

export const fetchSmartInModeTable1Action = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchSmartInModeTable1.fetch.start());
      await delay(1000);
      dispatch(fetchSmartInModeTable1.fetch.success());
    } catch (error) {
      dispatch(fetchSmartInModeTable1.fetch.error());
    }
  };
};

export const fetchSmartInModeTable2Action = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchSmartInModeTable2.fetch.start());
      await delay(1000);
      dispatch(fetchSmartInModeTable2.fetch.success());
    } catch (error) {
      dispatch(fetchSmartInModeTable2.fetch.error());
    }
  };
};
